import { Portal, useOutsideClick } from '@chakra-ui/react';
import algoliasearch from 'algoliasearch/lite';
import Container from 'components/atoms/Container/Container';
import React, { useRef } from 'react';
import { Configure, Index, InstantSearch, SearchBox } from 'react-instantsearch';
import { CSSTransition } from 'react-transition-group';
import { useGlobalStore } from 'stores/global';
import * as parentStyles from '../v2/Header.module.scss';
import BigcommerceHits from './BigcommerceHits';
import * as styles from './CustomSearch.module.scss';
import ProductHits from './ProductHits';
import TextHits from './TextHits';
import WordpressHits from './WordpressHits';
import { graphql, StaticQuery } from 'gatsby';

const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_API_KEY
);

const CustomSearchPage = ({searchPageData,  hideSearch }) => {
  const { setShowSearch, showSearch } = useGlobalStore(state => state);
  const searchRef = useRef(null);
  useOutsideClick({
    ref: searchRef,
    handler: () => setShowSearch(false)
  });
  
  const customSearchPages = searchPageData.allFile.edges[0]?.node.childrenSearchPageDataCsv || [];

  return (
    <InstantSearch searchClient={searchClient} indexName="prod_DEFAULT" insights={true}>
      <SearchBox
        onClick={() => {
          hideSearch(false);
          setShowSearch(true);
        }}
        placeholder="Search e.g. flea shampoo"
        onSubmit={e => {
          const searchText = e.target?.querySelector('input').value;
          if (searchText && window) {
            const landingSearchPage = customSearchPages.find(i => i.searchQuery === searchText) || false;
            setShowSearch(false);
            if (landingSearchPage) {
              window.location.replace(`${window.location.origin}${landingSearchPage.path}`);
            } else {
              window.location.assign(`/search?q=${searchText}`);
            }
          }
        }}
      />
      <Portal>
        <CSSTransition
          in={showSearch}
          timeout={300}
          classNames={{
            enter: parentStyles.menuEnter,
            enterDone: parentStyles.menuEnterActive,
            exit: parentStyles.menuExit,
            exitActive: parentStyles.menuExitActive
          }}
          unmountOnExit
        >
          <div className={`${styles.root} ${parentStyles.menu}`} ref={searchRef}>
            <Container size={'large'}>
              <section className="grid-suggest">
                <p className="title">suggestions</p>
                <Index indexName="prod_DEFAULT_query_suggestions">
                  <Configure hitsPerPage={4} />
                  <TextHits />
                </Index>
              </section>
              <BigcommerceHits />
              <WordpressHits />
              <section className="grid-product">
                <p className="title">products</p>
                <Index indexName="prod_DEFAULT">
                  <Configure hitsPerPage={4} />
                  <ProductHits />
                </Index>
              </section>
            </Container>
          </div>
        </CSSTransition>
      </Portal>
    </InstantSearch>
  );
};

export default function CustomSearch(props) {
  return (
    <StaticQuery
      query={graphql`
      query {
        allFile(filter: { relativePath: { eq: "SearchPageData.csv" } }) {
          edges {
            node {
              childrenSearchPageDataCsv {
                metaTitle
                metaDescription
                path
                searchQuery
                title
              }
            }
          }
        }
      }
      `}
      render={data => <CustomSearchPage searchPageData={data} {...props} />}
    />
  );
}
